import { UPDATE_CRED, GET_CREDS, SELECT_CRED, MODIFY_SELECTED_CRED, DISCARD_CRED, DELETE_CRED, TOGGLE_LOADING } from "./types";
import { getBaseURL } from "../../env/stage";
import { get, post, del } from "../../common/modules/http.client";
import store from "../store";
import { Credentials } from "../../common/interfaces/credentials/Credentials";
import { addMessage } from "./messageActions";

const AUTH_URL = getBaseURL() + "/credentials";

export const getCreds = () => (dispatch: any) => {
  get(AUTH_URL)
    .then((res) =>
      dispatch({
        type: GET_CREDS,
        payload: res,
      })
    )
    .catch((err) => {
      console.log("err", err);
      dispatch(addMessage("Error getting credentials", err.statusText, "error"));
    });
};

export const saveCred = (cred: Credentials) => async (dispatch: any) => {
  try {
    dispatch({
      type: TOGGLE_LOADING,
      payload: { status: true, loadingMessage: "loading..." },
    });

    const res = await post(AUTH_URL, cred);

    dispatch({
      type: UPDATE_CRED,
      payload: res,
    });

    dispatch({
      type: TOGGLE_LOADING,
      payload: { status: false, loadingMessage: "loading..." },
    });

    return res; // You can return the response if needed
  } catch (err) {
    console.error("Error saving credential", err);
    dispatch(addMessage("Error saving credential", err, "error"));
    throw err; // Re-throw the error if needed
  }
};


export const selectCred = (selectedId: string) => (dispatch: any) => {
  const creds = <Array<Credentials>>store.getState().auth.creds;
  const result = creds.find((cred) => cred.id === selectedId);

  dispatch({
    type: SELECT_CRED,
    payload: result ? JSON.parse(JSON.stringify(result)) : {},
  });
};
export const modifySelectedCred = (cred: Credentials) => (dispatch: any) => {
  dispatch({
    type: MODIFY_SELECTED_CRED,
    payload: cred,
  });
};
export const discardCred = () => (dispatch: any) => {
  dispatch({
    type: DISCARD_CRED,
    payload: {},
  });
};
export const deleteCred = (cred: Credentials) => (dispatch: any) => {
  del(AUTH_URL + "/" + cred.id)
    .then((res) => {
      dispatch({
        type: DELETE_CRED,
        payload: cred,
      });
    })
    .catch((err) => {
      console.log("err", err);
      dispatch(addMessage("Error deleting credential", err.statusText, "error"));
    });
};
